import { render, staticRenderFns } from "./store-form.vue?vue&type=template&id=df85a06c"
import script from "./store-form.vue?vue&type=script&lang=js"
export * from "./store-form.vue?vue&type=script&lang=js"
import style0 from "./store-form.vue?vue&type=style&index=0&id=df85a06c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports